import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class ProceedingError extends IncError {
    constructor(errorKey: string) {
        super(i18n.t(`error:proceeding.${errorKey}`));
        Object.setPrototypeOf(this, ProceedingError.prototype);
    }
}